module.exports = __webpack_public_path__ + "static/img/A132.9a802ed6.jpg";